// https://vuex.vuejs.org/en/actions.html

import { login_keycloak } from '../services/KeycloakService';
import { apiServer, hcpServer } from '../setup-axios'

export default {
  login ({ commit }, credentials) {
    return apiServer
      .post('/login', {
        username: credentials.username,
        password: credentials.password,
      })
      .then(({ data }) => {
        commit('SET_USER_DATA', data.data)
      })
        .catch(error => {
          commit('SET_ERROR_LOGIN', error.response.data.message)
        });
  },
  loginSSO ({ commit }) {
    login_keycloak()
    commit('SET_USER_DATA_KEYCLOAK')
  },
  logout ({ commit }) {
    commit('LOGOUT')
  },
  setSnackbar (context, payload) {
    context.commit('SET_SNACKBAR', payload)
  },
  setAnggota (context, payload) {
    context.commit('SET_ANGGOTA', payload)
  },
  setDeskripsiKendaraan (context, payload) {
    context.commit('SET_DESKRIPSI_KENDARAAN', payload)
  },
  setKendaraan (context, payload) {
    context.commit('SET_KENDARAAN', payload)
  },
  setSyarat (context, payload) {
    context.commit('SET_SYARAT', payload)
  },
  addDokumenSyarat (context, payload) {
    context.commit('APPEND_DOKUMEN_SYARAT', payload)
  },
  resetDokumenSyarat (context, payload) {
    context.commit('RESET_DOKUMEN_SYARAT', payload)
  },
  resetKendaraan (context, payload) {
    context.commit('RESET_KENDARAAN', payload)
  },
  resetWajibPajak (context, payload) {
    context.commit('RESET_WAJIB_PAJAK', payload)
  },
  setWajibPajak (context, payload) {
    context.commit('SET_WAJIB_PAJAK', payload)
  },
  setJenisTransaksi (context, payload) {
    context.commit('SET_JENIS_TRANSAKSI', payload)
  },
  upload (context, payload) {
    return hcpServer
        .put('/dokumen/' + payload.name, payload)
  },
  setIdentitas (context, payload) {
    context.commit('SET_IDENTITAS', payload)
  },
  resetDeskripsiKendaraan (context, payload) {
    context.commit('RESET_DESKRIPSI_KENDARAAN', payload)
  },
  setTujuanMutasi (context, payload) {
    context.commit('RESET_TUJUAN_MUTASI', payload)
  },
  resetTujuanMutasi (context, payload) {
    context.commit('RESET_TUJUAN_MUTASI', payload)
  },

}
